import React from 'react';
import './aiImprove.css';

/**
 * Compact toolbar when the user highlights text in the compose editor.
 */
export default function AISelectionToolbar({
  visible = false,
  top = 0,
  left = 0,
  onImprove,
  disabled = false,
}) {
  if (!visible) return null;

  return (
    <div
      className="aii-selection-toolbar"
      style={{ top, left }}
      role="toolbar"
      aria-label="Improve selection"
    >
      <button
        type="button"
        className="aii-selection-btn"
        onMouseDown={(e) => e.preventDefault()}
        onClick={onImprove}
        disabled={disabled}
      >
        <span className="aii-float-sparkle" aria-hidden="true">✨</span>
        Improve selection
      </button>
    </div>
  );
}
